import { EVIDENCE_LINKAGE_TYPE } from '@trustero/trustero-api-web/lib/attachment/attachment_pb'

export const isEvidenceFile = (mime: string): boolean => {
  const normalizedMime = mime.split(';')[0]?.trim().toLowerCase() || ''
  if (
    normalizedMime === 'text/csv' ||
    !(
      normalizedMime.startsWith('text') ||
      normalizedMime === 'application/protobuf'
    )
  ) {
    return true
  }
  return false
}

const getLinkageTypeString = (linkageType: EVIDENCE_LINKAGE_TYPE): string => {
  return linkageType === EVIDENCE_LINKAGE_TYPE.CONTROL_LINK
    ? 'control'
    : 'request'
}

export const getBulkUnlinkEvidenceMessage = (
  total: number,
  linkageType: EVIDENCE_LINKAGE_TYPE,
): string => {
  return `This evidence is part of a stack that samples the same data over time. Would you rather unlink all ${total} pieces of evidence from this ${getLinkageTypeString(
    linkageType,
  )}?`
}
